"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const bodyParts_1 = require("../../bodyParts");
const BodyParts_1 = require("../shared/BodyParts");
const female_back_png_1 = __importDefault(require("./female-back.png"));
const FemaleImage_1 = __importDefault(require("./FemaleImage"));
const paths = {
    [bodyParts_1.BodyPartsBack.LeftUpperSkull]: {
        d: `M310.61,60.818c-24.5,0-45.6,15.8-51.1,50.8c-0.4,2.8-0.6,10.7-0.6,17.4c15,1.6,34.4,2.4,53.8,2.4c0.1,0,0.2,0,0.3,0v-70.6
    c-0.4,0-0.7,0-1.1,0C311.51,60.818,311.01,60.818,310.61,60.818z`,
        "aria-label": "Back left upper skull",
    },
    [bodyParts_1.BodyPartsBack.RightUpperSkull]: {
        d: `M367.21,129.018c-0.1-7.6-0.6-14.1-1.5-18.9c-6.8-36.5-25-48.7-52.6-49.3v70.6
    C332.61,131.418,352.21,130.618,367.21,129.018z`,
        "aria-label": "Back right upper skull",
    },
    [bodyParts_1.BodyPartsBack.LeftLowerSkull]: {
        d: `M313.11,209.718v-78.3c-0.1,0-0.2,0-0.3,0c-19.4,0-38.8-0.8-53.8-2.4c0,2.8,0.1,5.4,0.2,7.3c0.3,6.5,5.2,38.3,6.5,51.2
    c0.4,3.9,1.3,7.5,2.4,10.8c7.5,7.5,25.7,11.3,44,11.4C312.41,209.718,312.71,209.718,313.11,209.718z`,
        "aria-label": "Back left lower skull",
    },
    [bodyParts_1.BodyPartsBack.RightLowerSkull]: {
        d: `M313.11,209.718c1.9,0,3.8,0,5.7-0.1c1.1,0,2.2-0.1,3.3-0.2c0.6,0,1.1-0.1,1.7-0.1c1.1-0.1,2.2-0.2,3.3-0.3
    c0.5-0.1,1.1-0.1,1.6-0.2c1.1-0.1,2.1-0.3,3.2-0.4c2.6-0.4,5.1-0.9,7.5-1.4c3.4-0.8,6.5-1.8,9.2-2.9c1.2-0.5,2.3-1,3.3-1.5
    c0.7-0.4,1.4-0.7,2-1.1c0.9-0.6,1.8-1.2,2.6-1.8c0.8-1.9,1.4-3.5,1.7-4.6c6.4-21.5,9.1-47,9-65.9c-15,1.6-34.5,2.4-54.1,2.4
    L313.11,209.718L313.11,209.718z`,
        "aria-label": "Back right lower skull",
    },
    [bodyParts_1.BodyPartsBack.LeftNeck]: {
        d: `M312.01,209.718c-18.4-0.1-36.5-3.9-44-11.4c2.4,7.6,5.9,13.3,6.6,15.3c1,2.8,1.1,23.8-0.8,27.3
    c-4.8,8.8-20.5,14-36.1,16.9c12.3,1.9,43.2,2.9,74.3,2.8c0.4,0,0.7,0,1.1,0v-50.9C312.71,209.718,312.41,209.718,312.01,209.718z`,
        "aria-label": "Back left neck",
    },
    [bodyParts_1.BodyPartsBack.RightNeck]: {
        d: `M351.91,202.518c-1,0.5-2.2,1.1-3.3,1.5c-2.8,1.1-5.9,2.1-9.2,2.9c-2.4,0.6-4.9,1-7.5,1.4c-1,0.2-2.1,0.3-3.2,0.4
    c-0.5,0.1-1.1,0.1-1.6,0.2c-1.1,0.1-2.2,0.2-3.3,0.3c-0.6,0-1.1,0.1-1.7,0.1c-1.1,0.1-2.2,0.1-3.3,0.2c-1.9,0.1-3.8,0.1-5.7,0.1
    v50.9c32.8-0.1,65.5-1.4,76.4-4c-24.7-4.1-44-6.1-38.6-44.1c0.1-0.5,3.4-7.7,5.6-13c-0.8,0.6-1.6,1.3-2.6,1.8
    C353.31,201.718,352.61,202.118,351.91,202.518z`,
        "aria-label": "Back right neck",
    },
    [bodyParts_1.BodyPartsBack.LeftShoulder]: {
        d: `M268.01,260.018c-13.2-0.5-24.1-1.2-30.3-2.2c-3,0.5-5.9,1-8.8,1.4v-0.1c-3.1,0.4-6.2,0.7-9.1,1
    c-19.5,1.7-30,7.2-40.7,17.7s-12.8,29-16.5,42.2c-0.4,1.5-0.8,3.2-1.2,4.9c33,3.3,69.5,5.6,108.1,6.6
    C267.01,307.618,266.51,283.818,268.01,260.018z`,
        "aria-label": "Back left shoulder",
    },
    [bodyParts_1.BodyPartsBack.LeftArm]: {
        d: `M161.41,324.918c-3,12.8-5.2,29.7-7.5,42.8c-0.2,1.1-0.4,2.2-0.6,3.4c-2.8,14.6-8.3,33.7-12,43.8
    c-4,10.8-11.3,33.3-15.3,47.3c-0.3,0.9-0.5,1.9-0.8,2.8c2.3,14,11.1,17.7,19.8,21.2c9.8,3.9,18.2,1.8,24.6-5.7
    c2.1-7.9,12.5-30.7,17.1-43.1c4.8-13,21.8-56.6,22.7-59.3c0.3-0.8,0.8-1.7,1.1-2c0-13.7-0.8-35.2-6.3-47.7
    C189.41,327.518,175.11,326.218,161.41,324.918z`,
        "aria-label": "Back left arm",
    },
    [bodyParts_1.BodyPartsBack.LeftElbow]: {
        d: `M144.91,486.118c-8.7-3.5-17.5-7.1-19.7-21.1c-3.9,12.7-9,23.2-12.8,31.4c-2.1,4.7-5.7,13-9,21.9
    c4.4-4.2,13-7.1,32.2-1.3c6.3,1.9,18.8,8,21.4,17.5c2.3-8.3,4.8-21.5,6.2-26c1.7-5.2,4.7-20.3,6-27c0.1-0.3,0.3-0.7,0.4-1
    C163.21,488.018,154.71,490.018,144.91,486.118z`,
        "aria-label": "Back left elbow",
    },
    [bodyParts_1.BodyPartsBack.LeftForearm]: {
        d: `M135.61,517.118c-19.2-5.9-27.8-3-32.2,1.2c-2.8,7.6-5.5,15.8-6.9,22.5c-3,14.7-3.8,31.2-6.2,46.5
    c-1.3,8.7-4.7,21.4-8.1,31.8c0,4.2,5,7,12.8,10.5c4.6,2.1,11.9,4.1,17.7,4.8c5.5-11.3,14.7-28.4,20.9-41.5
    c7.8-16.5,20-47.8,22.5-55.5c0.3-0.9,0.6-1.8,0.9-2.9C154.41,525.018,141.81,519.018,135.61,517.118z`,
        "aria-label": "Back left forearm",
    },
    [bodyParts_1.BodyPartsBack.LeftWrist]: {
        d: `M82.21,619.118c-2.6,8-5.2,14.7-7.1,17.1c-0.8,1-3.1,2-5.7,3c10.7,1.1,27.5,8.2,36.5,14.2
    c0.2-2.5,1-5.4,3.5-11.6c0.8-2,1.9-4.4,3.3-7.4c-5.8-0.7-13-2.8-17.6-4.9C87.31,626.018,82.21,623.318,82.21,619.118z`,
        "aria-label": "Back left wrist",
    },
    [bodyParts_1.BodyPartsBack.LeftHand]: {
        d: `M55.01,644.218c-5.9,1.7-7.1,4.2-11.8,6.4s-9.8,6.2-10.4,7.2s-2.8,2.9-5.2,5.7s-0.8,5.6,1.8,6.4
    s7.8-0.5,11.2-3.3s6.8-4.7,9.2-5.8s3.4,0.4,3.7,2.1s-2.6,9.6-4,14s-1.4,6.8-1.9,10.5s-2.6,12.9-3.2,17.7
    c-0.7,4.8-1.4,14.4-1.5,19.2s0.8,8.8,3.3,9.1s4.6-2,5.3-5.7s2.5-10.1,2.9-13.8c0.4-3.8,2.6-12.7,3.1-14.3c0.5-1.7,2.1-1.1,1.8,0.3
    c-0.2,1.4-1,5.5-1.5,8.2s-2.4,13.5-3.1,17.2s-1.5,14-1.3,18.2s2.8,6,5.2,4.8c2.3-1.2,4.6-6.5,5.3-10.8c0.7-4.3,2.2-10,3-15.2
    s2.9-15.1,4-18.6s2.4-0.9,2.3,0.9c-0.1,1.8-0.8,4.3-1,8.9s-1,15.6-1.5,19.8s-1.4,11,1.6,12.2s5.2-2.5,6.4-6.2s2.4-12.1,3.4-16.8
    s2.1-15.3,2.8-18.8s2.1-6.2,2.9-5.7c0.8,0.6,0.8,3.9,0,7.6s-1.7,9.8-2.7,13.5s-3.2,10.1,0,11.4s5.6-3.9,7-7.6s2.9-6.4,4.1-11
    c1.2-4.6,1.7-3.4,3.4-12.1c1.8-8.7,1.4-11.3,3.1-21.1s2.7-17.2,3-21.2c0.1-1.5,0.1-2.7,0.2-4.1c-9-6-25.7-13.1-36.5-14.2
    C65.01,641.318,58.71,643.118,55.01,644.218z`,
        "aria-label": "Back left hand",
    },
    [bodyParts_1.BodyPartsBack.RightShoulder]: {
        d: `M357.21,331.418c38.5-1,74.8-3.3,107.6-6.7c-1.3-6.1-2.9-13.1-5.1-21.2c-9.7-37.1-34.9-40.1-61.2-45.3
    c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c-2.7-0.5-5.4-1-8.1-1.4c-5.6,1.3-16.8,2.3-30.9,3
    C360.11,283.518,359.71,307.518,357.21,331.418z`,
        "aria-label": "Back right shoulder",
    },
    [bodyParts_1.BodyPartsBack.RightArm]: {
        d: `M490.71,430.218c-2.6-7.8-10-27.1-16.3-50.1c-1-3.6-1.7-6.7-2.3-10c-2.3-12.1-2.6-23.2-7.3-45.3
    c-13.9,1.4-28.5,2.7-43.5,3.7c-5.4,12.4-6,32.6-6,46.3c4,8.4,21.8,55.2,22.7,57.5c1.1,2.7,13.7,35.9,15.8,40
    c0.6,1.3,1.4,3.7,2.2,6.6c6.5,8.8,15.2,11.3,25.6,7.2c8.4-3.3,16.8-6.8,19.5-19.4C498.11,457.118,495.31,443.918,490.71,430.218z`,
        "aria-label": "Back right arm",
    },
    [bodyParts_1.BodyPartsBack.RightElbow]: {
        d: `M490.91,517.118c17.7-5.4,26.4-3.4,31.1,0.2c-3.5-10.3-7.1-17.9-8-19.6c-1.6-2.7-5.5-13.5-10-23.2
    c-1-2.2-2-4.9-2.9-7.8c-2.7,12.5-11,16.2-19.4,19.5c-10.4,4.1-19.2,1.3-25.7-7.3c1.8,6.4,3.8,15.2,4.3,17.1
    c1.4,5,3.1,13.2,4.2,18.2c0.7,3.4,1.6,9.4,4.9,20.6C471.71,525.218,484.61,519.018,490.91,517.118z`,
        "aria-label": "Back right elbow",
    },
    [bodyParts_1.BodyPartsBack.RightForearm]: {
        d: `M543.51,621.718c-6.9-23.1-12.5-67.1-15.5-82.4c-1.5-7.8-3.8-15.5-6-22c-4.7-3.6-13.4-5.5-31.1-0.1
    c-6.3,1.9-19.1,7.9-21.5,17.6c1.7,5.6,3.8,12.8,7,21.4c9.2,24.7,23,50.2,35.9,77.1c0.1,0.2,0.3,0.7,0.5,1.4
    c5.9-0.6,13.7-2.7,18.5-4.9C537.41,626.818,541.81,624.518,543.51,621.718z`,
        "aria-label": "Back right forearm",
    },
    [bodyParts_1.BodyPartsBack.RightWrist]: {
        d: `M545.71,628.218c-0.8-1.9-1.5-4-2.2-6.5c-1.6,2.9-6,5.1-12.1,7.8c-4.8,2.2-12.7,4.5-18.6,5.2
    c0.6,1.8,1.7,4.7,2.9,8c1.2,3.1,2,7.9,2.6,12.3c8-6,25.6-13.9,37.3-15.5C551.81,637.718,548.21,634.718,545.71,628.218z`,
        "aria-label": "Back right wrist",
    },
    [bodyParts_1.BodyPartsBack.RightHand]: {
        d: `M594.21,661.218c-2.2-1.8-3.2-5.8-5.2-6.6c-4.3-1.9-5.8-3.5-10.2-5.7c-2.8-1.4-7.7-4.1-16-6.8
    c-2.3-0.8-4.8-1.4-7.2-2.6c-11.7,1.6-29.3,9.5-37.3,15.5c0.3,2.2,0.5,4.3,0.5,6c0.1,4.8,2.8,18,3.2,22.4s0.5,11.8,3,17.6
    s1.5,11.1,3.3,14.1s2.2,6.2,5.2,11.3s5.2,5.6,6.4,2.2s0-8.2-0.8-9.9s-1.9-7.6-2.3-10.4s-1.6-7.6-0.8-9.8s3.2,2.4,3.3,4.5
    s1.4,12.3,2.1,16.3s2.2,14.1,3.4,19.1s4.5,8.6,6.8,7.1s2.8-6.8,2.6-9.1s-1.4-12.5-1.6-15.6s-1.7-15.8-1.9-17.5s2.2-1.6,2.8,0.6
    c0.5,2.2,2.1,9.6,2.8,13c0.8,3.4,2.9,15.4,3.7,21.7s4.9,10.2,7.5,10.4s3.1-6.7,3.2-9.2s-1-12.5-1.5-15.3s-4.2-24.8-3.2-24.8
    s3.6,14.8,4.8,21.2s2.8,13,6.7,13.1s3.2-4.8,3.4-12.8s-0.8-13.9-2.3-25.2s-3.3-17.9-4.4-22s-3.2-10.8-2.1-12.6s7.5,1.7,11.3,5.2
    s10.8,4.5,13.2,2.5S596.41,663.118,594.21,661.218z`,
        "aria-label": "Back right hand",
    },
    [bodyParts_1.BodyPartsBack.Cervical]: {
        d: `M357.21,331.418c2.5-24,3-47.9,1.4-71.9c-13.8,0.7-30.2,1-46.6,1c-15.5,0-30.9-0.2-44-0.6c-1.5,23.8-1,47.7,1.5,71.5
    c14.1,0.4,28.6,0.6,43.2,0.6C327.81,332.018,342.61,331.818,357.21,331.418z`,
        "aria-label": "Back cervical",
    },
    [bodyParts_1.BodyPartsBack.UpperSpinalThoracic]: {
        d: `M332.31,400.918c0.1-16.6,0.7-33.3,1.7-49.9c0.4-6.4,0.9-12.7,1.4-19.1c-7.5,0.1-15,0.2-22.7,0.2c-7.6,0-15.2-0.1-22.7-0.2
    c0.5,6.4,1,12.7,1.4,19.1c1,16.7,1.6,33.3,1.7,49.9c0,5.5,0,11,0,16.5c13,1.1,26.1,1.1,39.1,0.1
    C332.21,412.018,332.21,406.418,332.31,400.918z`,
        "aria-label": "Back upper spinal thoracic",
    },
    [bodyParts_1.BodyPartsBack.LowerSpinalThoracic]: {
        d: `M293.11,417.418c0,2.2,0,4.3-0.1,6.5c-0.1,5.7-0.2,11.4-0.4,17c-0.5,14.4-1.3,28.7-2.4,42.9l0,0c-0.3,3.9-0.6,7.8-1,11.8
    c0.3,0,0.5,0,0.8,0c7.2,0.2,14.5-1.2,21.9-1.6v-0.1c1.2-0.1,2.4-0.1,3.7-0.1c6.8,0,13.7,1.1,20.4,1.4c-0.3-3.8-0.7-7.6-1-11.4l0,0
    c-1.1-14.2-1.9-28.5-2.4-42.9c-0.2-5.7-0.3-11.4-0.4-17c0-2.1,0-4.3-0.1-6.4C319.21,418.618,306.21,418.518,293.11,417.418z`,
        "aria-label": "Back lower spinal thoracic",
    },
    [bodyParts_1.BodyPartsBack.LeftThoracic]: {
        d: `M290.31,483.818c1.1-14.2,1.9-28.5,2.4-42.9c0.2-5.7,0.3-11.4,0.4-17c0.1-7.7,0.1-15.3,0.1-23c-0.1-16.6-0.7-33.3-1.7-49.9
    c-0.4-6.4-0.9-12.7-1.4-19.1c-29.9-0.4-58.7-1.6-85.8-3.4c5.4,12.4,6.3,34,6.3,47.7l0,0c0,0,10.6,82.5,12.1,90.7
    c0.9,4.6,2.1,12.6,3.4,21.7c12.4,3.6,36.5,6.4,63.3,7.1C289.61,491.718,290.01,487.718,290.31,483.818L290.31,483.818z`,
        "aria-label": "Back left thoracic",
    },
    [bodyParts_1.BodyPartsBack.RightThoracic]: {
        d: `M335.41,331.918c-0.5,6.4-1,12.7-1.4,19.1c-1,16.7-1.6,33.3-1.7,49.9c-0.1,7.7,0,15.3,0.1,23c0.1,5.7,0.2,11.4,0.4,17
    c0.5,14.4,1.3,28.7,2.4,42.9l0,0c0.3,3.8,0.6,7.6,1,11.4c1.7,0.1,3.4,0.1,5.1,0.1c24.9-0.8,47-3.7,58.6-7.1
    c0.9-7.4,1.8-13.8,2.1-15.2c1.3-4.8,7.6-41.5,8.5-45.2c1.6-6.7,3.4-33.1,4.9-53c0-13.7,0.5-33.9,6-46.3
    C394.11,330.318,365.31,331.518,335.41,331.918z`,
        "aria-label": "Back right thoracic",
    },
    [bodyParts_1.BodyPartsBack.UpperSpinalLumbar]: {
        d: `M341.21,495.418c0.2,0,0.4,0,0.6,0v-0.1C341.61,495.318,341.41,495.318,341.21,495.418c-1.7-0.1-3.4-0.1-5.1-0.2
    c-6.7-0.3-13.5-1.4-20.4-1.4c-1.3,0-2.5,0-3.7,0.1v0.1c-7.4,0.4-14.7,1.8-21.9,1.6c-0.3,0-0.5,0-0.8,0c-1.5,16.1-3.2,43.7-5.5,65
    c19.3,1.2,38.6,1.4,57.9,0.6c-2.3-21.5-4.1-49.6-5.6-65.9C337.81,495.418,339.51,495.518,341.21,495.418z`,
        "aria-label": "Back upper spinal lumbar",
    },
    [bodyParts_1.BodyPartsBack.LowerSpinalLumbar]: {
        d: `M312.01,626.218c1.3,0.1,2.6,0.2,4,0.2c13.3,0,20-5.9,33.1-8.5l0,0c-2-10.5-3.9-31.1-5.5-41.7c-0.7-4.3-1.3-9.4-1.9-14.9
    c-19.3,0.8-38.6,0.6-57.9-0.6c-0.6,5.7-1.3,11-2,15.6c-1.6,10.2-3.4,30.3-5.3,40.4C294.91,618.018,298.81,625.018,312.01,626.218z`,
        "aria-label": "Back lower spinal lumbar",
    },
    [bodyParts_1.BodyPartsBack.LeftLumbar]: {
        d: `M283.61,495.318c-24.4-0.9-46-3.5-57.6-6.8c2.1,14.6,4.2,31.9,4.7,42.7c0.8,17.5-3,26-8.8,39.2
    c-2.3,5.4-6.5,15.5-11.1,27.5c12.6-6.7,39.6,18.4,58.9,18.4c2.5,0,4.7,0.1,6.8,0.3c1.9-10.1,3.7-30.2,5.3-40.4
    c0.7-4.5,1.4-9.8,2-15.6c2.3-21.4,4-49,5.5-65.1C287.41,495.418,285.51,495.418,283.61,495.318z`,
        "aria-label": "Back left lumbar",
    },
    [bodyParts_1.BodyPartsBack.RightLumbar]: {
        d: `M416.71,602.318c-3-8.7-5.9-17.5-8.8-23.8c-4.3-9.2-11.8-27.5-12.7-31.6c-1-4.6,0.9-27.8,1.5-32.5c0.4-2.8,1.8-15.4,3.1-26
    c-11.6,3.4-33.7,6.2-58.6,7c-1.7,0.1-3.4,0-5.1-0.1c1.9,20.5,4.2,59.5,7.5,80.8c1.7,10.6,3.5,31.2,5.5,41.7c3.8-0.8,8-1.3,13.2-1.3
    C381.61,616.518,406.41,594.218,416.71,602.318z`,
        "aria-label": "Back right lumbar",
    },
    [bodyParts_1.BodyPartsBack.Sacrum]: {
        d: `M340.51,620.318c-8.1,2.8-14.4,6.1-24.5,6.1c-1.4,0-2.7-0.1-4-0.2c-11-1-15.6-6-27.4-8.5c9.3,44.6,3,115.3-19.3,140.9
    c12.8-1.5,25.5-7.2,37.3-17.9c0.2-1.1,0.7-1.7,1.7-2.2c1.5-0.8,5.2-6.9,6.2-8.8c0.9-1.6-0.2-3.7,1.7-4.2c0.2,0,0.5-0.1,0.8-0.1
    c3.2,0,2.2,2.2,3.1,4.4s5.2,6.8,6.8,9.2c0.2,0.4,0.4,0.7,0.6,1c11.5,10.7,23.9,16.5,36.5,18.3
    C338.41,732.918,332.01,664.818,340.51,620.318z`,
        "aria-label": "Back sacrum",
    },
    [bodyParts_1.BodyPartsBack.LeftButtock]: {
        d: `M284.61,617.718c-4-0.8-8.8-1.4-14.9-1.4c-19.3,0-46.3-25.1-58.9-18.4c-6.7,17.5-14.2,39.1-18,55.1
    c-5.7,23.8-7,46.6-7.2,63.7c20.3,27.3,50.3,45.4,79.7,41.9C287.61,733.018,293.91,662.318,284.61,617.718z`,
        "aria-label": "Back left buttock",
    },
    [bodyParts_1.BodyPartsBack.LeftHamstring]: {
        d: `M185.61,716.718c0,2.3-0.1,4.5-0.1,6.5c0,17.5,1.8,35.2,3.8,48s13.2,79.2,16,96.2c2.2,13.4,7.4,52,11.4,76.6
    c12.8,17.4,28.6,21.1,42.4,21.9c13.6,0.9,27.4-1.6,35.6-9.2c0.6-15.5,0.9-32.5,0.6-40.3c-0.5-14.8-2.2-56-2.1-67.9s2.6-35,4.2-43.8
    s5-31.5,5.2-41.6s0-17-0.2-20c-0.1-1.1,0.1-1.8,0.2-2.4C263.81,776.318,214.71,756.018,185.61,716.718z`,
        "aria-label": "Back left hamstring",
    },
    [bodyParts_1.BodyPartsBack.LeftKnee]: {
        d: `M259.01,966.018c-13.8-0.9-29.6-4.5-42.4-21.9c1.1,6.6,2,12.1,2.8,15.9c3.7,18,2.7,23.8,4.2,33
    s0.8,17.5-1.7,33.5c-0.2,1.2-0.3,2.6-0.5,4.2c6.1-11.6,19.8-14,31.8-12.7c12.4,1.3,28.6,6,35.1,11.2c-0.2-4-0.3-7.9-0.4-11.4
    c-0.2-11.5,3.5-22.5,4.8-30.3c0.6-3.7,1.3-16.6,1.9-30.7C286.41,964.418,272.71,966.918,259.01,966.018z`,
        "aria-label": "Back left knee",
    },
    [bodyParts_1.BodyPartsBack.LeftCalf]: {
        d: `M221.41,1030.718c-1.6,18.6,0.5,58.3,0.5,68.5c0,11,3.2,52.8,8,69.7c2.1,7.2,4.5,18.6,6.9,30.3
    c5.1,7,16.4,9.5,26,9.9c9.1,0.4,18.7-4,23.6-12.1c1-9.1,1.9-17.9,2.4-23.8c1.3-15.8,6.3-57.7,7-66.8s-0.2-34.5-3.5-48
    c-2.3-9.4-3.4-19.8-3.9-29.1c-6.5-5.2-22.7-9.9-35.1-11.2C241.21,1016.718,227.51,1019.118,221.41,1030.718z`,
        "aria-label": "Back left calf",
    },
    [bodyParts_1.BodyPartsBack.LeftAnkle]: {
        d: `M262.71,1209.018c-9.6-0.4-20.9-2.9-26-9.9c3.1,15.7,6,32,7.5,39.6c2.5,13.4,2.7,35.9,2.1,40
    c-0.1,1-0.4,1.7-0.7,2.1c3.3,10.5,2.5,18,1.7,29.6c-0.2,3.5-0.1,13.3,0.4,20.2c0.5,0.6,1,1.1,1.6,1.6c4.9-14.6,28.5-15,35.1-7.9
    c1.7-5.9,1-11.1,2.1-18.4c1.1-8-0.1-13.1-0.5-16.6s1.9-5.1,3.4-12.1s-1.1-12.9-3-19.6s-2.5-13.6-3-23c-0.3-5.9,1.3-22.3,2.9-37.7
    C281.41,1205.018,271.81,1209.418,262.71,1209.018z`,
        "aria-label": "Back left ankle",
    },
    [bodyParts_1.BodyPartsBack.LeftAchilles]: {
        d: `M249.31,1332.318c4,3.7,9.4,6.4,16,6.8c10.6,0.8,16.1-6.1,18.5-12.9c0.2-0.6,0.4-1.2,0.6-1.8
    C277.81,1317.318,254.21,1317.718,249.31,1332.318z`,
        "aria-label": "Back left achilles",
    },
    [bodyParts_1.BodyPartsBack.LeftForefoot]: {
        d: `M247.31,1310.418c0.8-11.6,1.6-19.1-1.7-29.6c-0.9,1.3-2.5,0.7-4.4,2.4c-1.3,1.2-1.6,2.6-3.8,2.7
    s-4.7,2.2-5.5,3.8c-0.8,1.5-2.7,0.2-4.9,1.4s-3,3.7-2.4,6.2c0.6,2.6,2.3,3.2,2.4,4.9s1,4.2,3.8,7.8s9.2,7.2,12.9,14.6
    c1.1,2.1,2.4,4.2,4.1,6.1C247.21,1323.718,247.01,1313.918,247.31,1310.418z`,
        "aria-label": "Left forefoot",
    },
    [bodyParts_1.BodyPartsBack.RightButtock]: {
        d: `M434.71,668.018c-3-18.5-9-41.7-13.7-53.7c-1.5-3.8-2.9-7.9-4.3-12c-10.3-8.1-35.1,14.2-54.4,14.3
    c-9.5,0-16.1,1.7-21.8,3.7c-8.5,44.5-2.1,112.6,19.5,138c29.4,4.2,59.4-13.3,80-40.3C439.41,699.418,436.91,681.618,434.71,668.018
    z`,
        "aria-label": "Back right buttock",
    },
    [bodyParts_1.BodyPartsBack.RightHamstring]: {
        d: `M323.51,740.018c0.7,1.3-0.1,1.3-0.2,3.5c-0.1,2.6-0.8,6.8-0.3,16.3s3,33.5,6.2,48.7s3.5,45.5,3.2,59.3
    s-1.8,43.3-2,53c-0.1,5.8,0.2,21.1,0.7,35.1c8.1,8.3,22.3,11,36.4,10.1c13.4-0.8,28.7-4.3,41.3-20.5c1.4-8.7,2.7-16.7,3.1-21
    c1-10.8,4.5-31.2,6.5-44.7s9.2-56.5,11.5-71.5s8.3-44.3,9.8-70c0.4-6.8,0.4-13.6,0.2-20.2
    C410.51,756.618,361.91,775.818,323.51,740.018z`,
        "aria-label": "Back right hamstring",
    },
    [bodyParts_1.BodyPartsBack.RightKnee]: {
        d: `M367.51,966.018c-14.2,0.9-28.4-1.8-36.4-10.1c0.3,9.5,0.7,18.3,1,22.9c0.8,11.5,5.8,24.2,5.8,40.7
    c0,3.6-0.1,7-0.3,10.2c6-5.4,22.9-10.4,35.7-11.7c11.4-1.2,24.3,0.9,30.8,11c-0.7-4.9-1.5-9.5-2.1-13.5
    c-1.5-10.3-0.3-21.2,1.2-34.3c0.9-7.9,3.5-22.7,5.6-35.7C396.21,961.718,380.91,965.218,367.51,966.018z`,
        "aria-label": "Back right knee",
    },
    [bodyParts_1.BodyPartsBack.RightCalf]: {
        d: `M373.31,1018.018c-12.8,1.4-29.7,6.3-35.7,11.7c-0.6,11.6-2.3,21.9-5.4,37.1c-4,19.5-2.2,39.5-0.2,53.8
    s3,38.5,6.2,63.5c0.5,4.1,1,8.1,1.4,11.9c4.7,8.7,14.7,13.4,24.1,13c8.9-0.4,19.3-2.6,24.8-8.5c3.6-15.6,7.6-32.3,9.8-44.5
    c4-22.7,5.5-50.7,5.5-59.2s2.2-28.3,2.3-42.3c0.1-8.7-0.9-17.6-2.1-25.5C397.61,1018.918,384.71,1016.818,373.31,1018.018z`,
        "aria-label": "Back right calf",
    },
    [bodyParts_1.BodyPartsBack.RightAnkle]: {
        d: `M339.61,1196.018c2.2,19.2,3.3,34.3,2.6,47.6c-0.4,7.8-3.2,15-5.4,22.2c-2.2,7.2-0.2,12.7,1.2,16.7
    s1.6,7,0.6,11.5s1.2,14.1,1.4,19.1c0.1,3,0,7.6,1.3,12.3c5-8.1,30-8.4,35.7,6.1c0.7-0.8,1.4-1.6,1.9-2.4c0.4-6.8,0.6-15.5,0.3-18.8
    c-0.8-11.4-1.6-18.8,1.5-29.1c-0.1-0.1-0.2-0.2-0.4-0.4c-1.5-1.7-1-7.3-1.3-10.7s0.5-18.8,2.7-36c1-7.9,3.8-20.4,6.9-33.8
    c-5.5,5.9-15.9,8.1-24.8,8.5C354.31,1209.418,344.41,1204.718,339.61,1196.018z`,
        "aria-label": "Back right ankle",
    },
    [bodyParts_1.BodyPartsBack.RightAchilles]: {
        d: `M341.31,1325.518c0.8,3.1,2.3,6.2,4.8,8.9c6.2,6.9,20.1,3.8,25.8,1.1c2-0.9,3.6-2.3,5.1-3.9
    C371.31,1317.018,346.31,1317.418,341.31,1325.518z`,
        "aria-label": "Back right achilles",
    },
    [bodyParts_1.BodyPartsBack.RightForefoot]: {
        d: `M379.21,1310.418c0.2,3.3,0.1,12-0.3,18.8c1.6-2.3,2.8-4.5,3.4-5.9c1.3-2.8,9.5-11.3,12.8-14.9
    s2.5-5.1,2.5-7.1s2-2,2.5-5.3s-1.8-4.8-2.9-5.6s-4.1-0.8-4.2-1.4s-1.2-1.9-3.2-2.9s-4,0.7-4.9-1.1c-0.8-1.6-2.6-2.2-4.1-3.6
    C377.61,1291.618,378.41,1299.018,379.21,1310.418z`,
        "aria-label": "Right forefoot",
    },
};
const BackFemaleBodyParts = (props) => {
    return react_1.default.createElement(BodyParts_1.BodyParts, Object.assign({ image: react_1.default.createElement(FemaleImage_1.default, { href: female_back_png_1.default }), paths: paths }, props));
};
exports.default = BackFemaleBodyParts;
//# sourceMappingURL=BackFemaleBodyParts.js.map